/** Conteúdo do rodapé marketing (rodape.v1). */

const str = (v) => String(v ?? "").trim();
const strList = (v) => (Array.isArray(v) ? v.map((x) => str(x)).filter(Boolean) : []);

function parseMaybe(raw) {
  if (!raw) return null;
  if (typeof raw === "string") {
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }
  return raw;
}

export function emptyRodapePage() {
  return sanitizeRodapePage({
    format: "rodape.v1",
    tagline: "",
    taglineHighlight: "",
    subtitle: "",
    chips: [],
    phones: [],
    quickLinks: [],
    socialTitle: "",
    legalLine: "",
    logoAlt: "",
    accessibilityLabel: "",
    accessibilityHref: "",
  });
}

export function sanitizeRodapePage(src) {
  const v = src && typeof src === "object" ? src : {};

  const chips = Array.isArray(v.chips)
    ? v.chips
        .map((c) => {
          const title = str(c?.title);
          if (!title) return null;
          return {
            icon: str(c?.icon) || undefined,
            eyebrow: str(c?.eyebrow) || undefined,
            title,
            subtitle: str(c?.subtitle) || undefined,
          };
        })
        .filter(Boolean)
    : [];

  const phones = Array.isArray(v.phones)
    ? v.phones
        .map((p) => {
          const number = str(p?.number);
          const label = str(p?.label);
          if (!number && !label) return null;
          return {
            label: label || undefined,
            number: number || undefined,
            href: str(p?.href) || undefined,
            note: str(p?.note) || undefined,
          };
        })
        .filter(Boolean)
    : [];

  const quickLinks = Array.isArray(v.quickLinks)
    ? v.quickLinks
        .map((l) => {
          const label = str(l?.label);
          const href = str(l?.href);
          if (!label || !href) return null;
          return { label, href };
        })
        .filter(Boolean)
    : [];

  return {
    format: "rodape.v1",
    tagline: str(v.tagline),
    taglineHighlight: str(v.taglineHighlight) || undefined,
    subtitle: str(v.subtitle),
    chips,
    phones,
    quickLinks,
    socialTitle: str(v.socialTitle) || undefined,
    legalLine: str(v.legalLine) || undefined,
    logoAlt: str(v.logoAlt) || undefined,
    accessibilityLabel: str(v.accessibilityLabel) || undefined,
    accessibilityHref: str(v.accessibilityHref) || undefined,
  };
}

export function parseRodapePageFromContent(contentData) {
  const raw = parseMaybe(contentData?.conteudo_json);
  if (raw?.format === "rodape.v1") {
    return sanitizeRodapePage(raw);
  }
  return emptyRodapePage();
}
